







































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { fetchCambioServicio } from './fetchCambioServicio';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Snotify } from '@/snotify/Snotify';

@Component({
  components: {
    DatePicker,
    FormFieldsContainer,
  },
})
export default class NuevoCambioActivoCliente extends Vue {
  constructor() {
    super();
  }

  @Prop({ default: null }) accion_modal: any;
  @Prop({ default: null }) cliente_id_entrante: any;
  @Prop({ default: null }) flota_entrante: any;
  @Prop({ default: null }) patente_entrante: any;
  @Prop({ default: null }) titulo: any;
  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify;
  model_serienumero: any = null;
  model_tipoeqname: any = null;
  lista_clientename: any = null;
  lista_flotaname: any[] = [];
  lista_patentes: any[] = [];

  formFields: FormFieldDefMap = {
    patente_vehiculo_new: {
      label: 'Patente',
      id: '',
      value: '',
    },
    cod_flota_new: {
      label: 'Flota',
      id: '',
      value: '',
    },
    cliente_id_new: {
      label: 'Cliente',
      id: '',
      value: '',
    },
  };

  async get_tipoeq() {
    this.loadingService.showLoading();
    return fetchCambioServicio({}, 'conectaCambioServicio/getClientes')
      .then((data: any) => {
        this.loadingService.hideLoading();
        let res = data.data.data;
        this.lista_clientename = res;
      })
      .catch((error: any) => {
        this.loadingService.hideLoading();
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  } //end get_tipoeq

  async get_flota() {
    this.loadingService.showLoading();

    return fetchCambioServicio(
      { id_cliente: this.formFields.cliente_id_new.value },
      'conectaCambioServicio/getFlotas'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          let res = data.data.data.LISTA;
          this.lista_patentes = data.data.data2.LISTA;
          this.lista_flotaname = res;
        } else {
          this.loadingService.hideLoading();
          this.lista_patentes = [];
          this.lista_flotaname = [];
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        this.loadingService.hideLoading();
        this.lista_patentes = [];
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  } //end buscar_serie_numero
  async get_pantente() {
    this.loadingService.showLoading();

    return fetchCambioServicio(
      {
        id_cliente: this.formFields.cliente_id_new.value,
        patente: this.formFields.cod_flota_new.value,
      },
      'conectaCambioServicio/getPatente'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          this.lista_patentes = data.data.data2.LISTA;
        } else {
          this.loadingService.hideLoading();
          this.lista_patentes = [];
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        this.loadingService.hideLoading();
        this.lista_patentes = [];
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  mounted() {
    if (this.accion_modal == 'EDITAR') {
      this.formFields.cliente_id_new.value = this.cliente_id_entrante;
      this.formFields.cod_flota_new.value = this.flota_entrante;
      this.formFields.patente_vehiculo_new.value = this.patente_entrante;
    } else {
      this.get_tipoeq();
    }
  }
  @Watch('formFields')
  onModelTipoCambioChanged(val: any, oldVal: any) {
    this.$emit('input', this.formFields);
  }
} //end class
